<template>
  <!--eslint-disable -->
  <v-dialog
    persistent
    v-model="unitsDialog"
    max-width="70%"
    height="70vh"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card flat class="exemptions">
      <v-toolbar flat dark sticky color="primary" elevation="0">
        <v-toolbar-title class="text-lg-h6 mx-auto d-flex mt-3">
          <span class="mr-1">{{ formData.programme }}</span> Select Papers/Units
          For Remark
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="overflow-y-auto overflow-x-hidden"
        style="max-height: 70vh"
      >
        <v-data-table
          :headers="headers"
          :items="remarkUnits"
          hide-default-footer
          item-key="code"
        >
          <template v-slot:[`item.description`]="{ item }">
            <div class="d-flex">
              <span class="font-weight-bold">{{ item.code }}: </span>
              <span class="ml-2">{{ item.description }}</span>
            </div>
          </template>
          <template v-slot:[`item.examCenter`]="{ item }">
            {{ `${item.examCenters.Name}(${item.examCenters.Code})` }}
          </template>
          <template v-slot:[`item.examDate`]="{ item }">
            {{ formatDate(item.examDate) }}
          </template>
          <template v-slot:[`item.select`]="{ item }">
            <v-layout>
              <v-checkbox
                small
                :value="item"
                class="shrink mr-2"
                v-model="formData.examRemarkLines"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:[`item.grade`]="{ item }">
            <v-select
              dense
              outlined
              v-model="setGrade"
              @input="setGradeFunc(item, $event)"
              :items="grades"
              class="mt-4 select"
              return-object
              label="Grade"
              :disabled="item.isNotRemarked"
              ref="grade"
              :item-text="(item) => item.description"
              :item-value="(item) => item.code"
              :rules="rules.required"
            />
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="selectedUnits">done</v-btn>
        <v-btn outlined color="error" @click="closeDialog"> close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */ 
import { helper } from "@/packages/dashboard/utils";
export default {
  name: "RemarkUnitsDialog",
  props: {
    remarkUnitsDialogBox: Boolean,
    formData: Object,
  },
  data() {
    return {
      other: false,
      headers: [
        {
          text: "Unit",
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: "Paper",
          align: "start",
          sortable: false,
          value: "paper",
        },
        {
          text: "Exam Center",
          align: "start",
          sortable: false,
          value: "examCenter",
        },
        {
          text: "Exam Date",
          align: "start",
          sortable: false,
          value: "examDate",
        },
        { text: "Remark", value: "select", sortable: false },
        { text: "Grade", value: "grade" },
      ],
    };
  },
  computed: {
    unitsDialog: {
      get() {
        return this.remarkUnitsDialogBox;
      },
      set(value) {
        this.setRemarkUnitsModal(value);
      },
    },
    remarkUnits() {
      const units = this.$store.getters["Remark/remarkGetter"]("remarkUnits");
      return units
        ? units.filter((item) => {
            const unit = this.formData.examRemarkLines.filter(
              (el) => el.unit === item.unit && el.lineNo,
            ).length;
            item.isNotRemarked =
              this.formData.examRemarkLines.filter(
                (el) => el.unit === item.unit,
              ).length === 0;
            return unit === 0;
          })
        : [];
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
      };
    },
    grades() {
      return this.$store.getters["Exemption/exemptionGetter"]("grades");
    },
    setGrade: {
      get() {
        return this.formData.examRemarkLines.gradeScored;
      },
      set(value) {
        this.formData.examRemarkLines.gradeScored = value;
      },
    },
  },
  methods: {
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    setRemarkUnitsModal(value) {
      this.$emit("setRemarkUnitsModal", value);
    },
    closeDialog() {
      this.unitsDialog = false;
      this.other = false;
    },
    selectedUnits() {
      this.unitsDialog = false;
    },
    uppercase() {
      this.formData.examRemarkLines.grade =
        this.formData.examRemarkLines.grade.toUpperCase();
    },
    setGradeFunc(item, event) {
      this.formData.examRemarkLines.map((el) => {
        if (el.unit === item.unit) {
          el.gradeScored = event.code;
          return el;
        }
      });
    },
    save() {
      this.snack = true;
    },
    cancel() {
      this.snack = true;
    },
  },
};
</script>

<style scoped>
@import url("../../../../exemptions/styles/exemption.css");
</style>
